// extracted by mini-css-extract-plugin
module.exports = {"image-wrap":"image-wrap__2HjCU","imageWrap":"image-wrap__2HjCU","image":"image__npp2k","carousel":"carousel__UbPQe","marker":"marker__5vn1N","markers":"markers__3D_g_"};